import { render, staticRenderFns } from "./TabDataPreview.vue?vue&type=template&id=23dd0b4d&scoped=true"
import script from "./TabDataPreview.vue?vue&type=script&lang=js"
export * from "./TabDataPreview.vue?vue&type=script&lang=js"
import style0 from "./TabDataPreview.vue?vue&type=style&index=0&id=23dd0b4d&lang=scss&scoped=true"
import style1 from "./TabDataPreview.vue?vue&type=style&index=1&id=23dd0b4d&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23dd0b4d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23dd0b4d')) {
      api.createRecord('23dd0b4d', component.options)
    } else {
      api.reload('23dd0b4d', component.options)
    }
    module.hot.accept("./TabDataPreview.vue?vue&type=template&id=23dd0b4d&scoped=true", function () {
      api.rerender('23dd0b4d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataset/data/TabDataPreview.vue"
export default component.exports